import * as log from 'loglevel';

// when an error happens in between state update
// reports error via broker

export default broker => store => next => action => {
  try {
    return next(action);
  } catch (error) {
    const errorInfo = {
      extra: {
        action,
        state: store.getState()
      }
    };

    if (broker) {
      broker.onError(error, errorInfo);
    }

    log.error(error, errorInfo);
    throw error;
  }
};
